import React, { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import ProductionPlan from './ProductionPlan';
import ProductionLocInventory from "./ProductionLocInventory";
import FinishedGoodInventory from "./FinishedGoodInventory";
import SemiFinishedGoodInventory from "./SemiFinishedGoodInventory";
import RejectedFinishedProduct from "./RejectedFinishedProduct";
import RejectedSemiFinishedProduct from "./RejectedSemiFinishedProduct";
import StepwiseInventory from "./StepwiseInventory";

const ProductionTabs = () => {
    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <Box ml={1}>
            {/* Tab Navigation */}
            <Tabs sx={{paddingLeft:"190px", paddingTop:"80px"}} value={activeTab} onChange={handleTabChange} variant="scrollable">
                <Tab label="Production Plan" />
                <Tab label="Production Loc Inv" />
                <Tab label="Stepwise Inv" />
                <Tab label="Semifinish Products" />
                <Tab label="Rejected Semifinish Products" />
                <Tab label="Finish Products" />
                {/* <Tab label="Rejected Finish Product" /> */}
                
            </Tabs>

            {/* Render Components Based on Active Tab */}
            <Box mt={2}>
                {activeTab === 0 && <ProductionPlan />}
                {activeTab === 1 && <ProductionLocInventory />}
                {activeTab === 2 && <StepwiseInventory />}
                {activeTab === 3 && <SemiFinishedGoodInventory />}
                {activeTab === 4 && <RejectedSemiFinishedProduct />}
                {activeTab === 5 && <FinishedGoodInventory />}
                {/* {activeTab === 6 && <RejectedFinishedProduct />} */}
                
            </Box>
        </Box>
    );
};

export default ProductionTabs;
